import { __assign, __rest } from "tslib";
import React from 'react';
import { GooglePlusShareButton, FacebookShareButton, TumblrShareButton, TwitterShareButton, PinterestShareButton, RedditShareButton, EmailShareButton, } from 'react-share';
export var ShareButton = function (_a) {
    var type = _a.type, url = _a.url, title = _a.title, via = _a.via, _b = _a.hashtags, hashtags = _b === void 0 ? [] : _b, _c = _a.media, media = _c === void 0 ? url : _c, children = _a.children, props = __rest(_a, ["type", "url", "title", "via", "hashtags", "media", "children"]);
    switch (type) {
        case 'google':
            return (React.createElement(GooglePlusShareButton, __assign({ url: url }, props), children));
        case 'facebook':
            return (React.createElement(FacebookShareButton, __assign({ quote: title, hashtag: hashtags.length ? "#" + hashtags[0] : '', url: url }, props), children));
        case 'twitter':
            return (React.createElement(TwitterShareButton, __assign({ url: url, title: title, via: via, hashtags: hashtags }, props), children));
        case 'pinterest':
            return (React.createElement(PinterestShareButton, __assign({ url: url, media: media, description: title }, props), children));
        case 'reddit':
            return (React.createElement(RedditShareButton, __assign({ url: url, title: title }, props), children));
        case 'tumblr':
            return (React.createElement(TumblrShareButton, __assign({ url: url, title: title, tags: hashtags, caption: title }, props), children));
        case 'email':
            return (React.createElement(EmailShareButton, __assign({ url: url, subject: title, body: url }, props), children));
        default:
            return null;
    }
};
ShareButton.displayName = 'ShareButton';
export default ShareButton;
//# sourceMappingURL=ShareButton.js.map